// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"766":"08da9a83","821":"bd3f20ce"}[chunkId] + ".chunk.js";
};